import { __extends, __spreadArray } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateAppMessageResult, formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for meeting module related message requests.
 */
var MeetingMessageHandler = /** @class */ (function (_super) {
    __extends(MeetingMessageHandler, _super);
    function MeetingMessageHandler(appSdkHost, meetingService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.meetingService = meetingService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    MeetingMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.meeting.getIncomingClientAudioState, function () { return formulateSdkResponse(null, _this.meetingService.getIncomingClientAudioState); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.getIncomingClientAudioState, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.toggleIncomingClientAudio, function () { return formulateSdkResponse(null, _this.meetingService.toggleIncomingClientAudio); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.toggleIncomingClientAudio, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.getMeetingDetails, function () { return formulateSdkResponse(null, _this.meetingService.getMeetingDetails); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.meeting.getMeetingDetails, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.meeting.getAuthenticationTokenForAnonymousUser, function () { return formulateSdkResponse(null, _this.meetingService.getAuthenticationTokenForAnonymousUser); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.getAuthenticationTokenForAnonymousUser, error, scenario);
            },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.meeting.getLiveStreamState, function () { return formulateSdkResponse(null, _this.meetingService.getLiveStreamState); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.meeting.getLiveStreamState, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.meeting.requestStartLiveStreaming, function (_) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return callServiceAndFormulateAppMessageResult.apply(void 0, __spreadArray([_this.meetingService.requestStartLiveStreaming], params, false));
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.requestStartLiveStreaming, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.requestStopLiveStreaming, function () { return formulateSdkResponse(null, _this.meetingService.requestStopLiveStreaming); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.requestStopLiveStreaming, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.shareAppContentToStage, function (_, params) { return formulateSdkResponse(params, _this.meetingService.shareAppContentToStage); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.meeting.shareAppContentToStage, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.meeting.appShareButton.setOptions, function (_, params) {
            return formulateSdkResponse(params, _this.meetingService.appShareButton.setOptions);
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.appShareButton.setOptions, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.getAppContentStageSharingCapabilities, function () { return formulateSdkResponse(null, _this.meetingService.getAppContentStageSharingCapabilities); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.getAppContentStageSharingCapabilities, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.stopSharingAppContentToStage, function () { return formulateSdkResponse(null, _this.meetingService.stopSharingAppContentToStage); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.stopSharingAppContentToStage, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.getAppContentStageSharingState, function () { return formulateSdkResponse(null, _this.meetingService.getAppContentStageSharingState); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.getAppContentStageSharingState, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.requestAppAudioHandling, function (_, params) { return formulateSdkResponse(params, _this.meetingService.requestAppAudioHandling); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.meeting.requestAppAudioHandling, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.meeting.updateMicState, function (_) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            return callServiceAndFormulateAppMessageResult.apply(void 0, __spreadArray([_this.meetingService.updateMicState], params, false));
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.meeting.updateMicState, error, scenario); },
        });
    };
    //Check whether meeting Services are provided
    MeetingMessageHandler.prototype.validateDependencies = function () {
        if (!this.meetingService) {
            throw 'No meetingService provided';
        }
    };
    return MeetingMessageHandler;
}(BaseMessageHandler));
export { MeetingMessageHandler };
//# sourceMappingURL=meeting-message-handler.js.map